import { ChakraConfirmationDialog } from 'app/components/Dialogs';
import { Dispatch, SetStateAction } from 'react';
import { AudioDialogState } from 'app/components/Playlist/PlaylistRoomAudiosList/types';
import { audioDialogDefaultState } from 'app/components/Playlist/PlaylistRoomAudiosList/constants';

interface DeleteAudioDialogProps {
  audioRemoveDialog: AudioDialogState;
  setAudioRemoveDialog: Dispatch<SetStateAction<AudioDialogState>>;
  onRemoveAudio: (audioGuid: string) => Promise<void>;
}

export const DeleteAudioDialog = ({
  setAudioRemoveDialog,
  audioRemoveDialog,
  onRemoveAudio,
}: DeleteAudioDialogProps) => {
  const handleRemove = async (audioGuid: string) => {
    try {
      await onRemoveAudio(audioGuid);
      setAudioRemoveDialog({ ...audioRemoveDialog, open: false });
    } catch (e) {
      // proceed
    }
  };

  return (
    <ChakraConfirmationDialog
      title="Remove Audio"
      handleAction={() => handleRemove(audioRemoveDialog.audio?.guid || '')}
      isOpen={audioRemoveDialog.open}
      onClose={() =>
        setAudioRemoveDialog({ ...audioRemoveDialog, open: false })
      }
      onCloseComplete={() => setAudioRemoveDialog(audioDialogDefaultState)}
      actionButtonText="Remove"
      message={
        <>
          Are you sure you want to remove
          <b>
            &nbsp;
            {audioRemoveDialog.audio?.audio.title}
          </b>
          &nbsp;?
        </>
      }
    />
  );
};
